import request from '@/utils/axios'
import qs from 'qs'

/**
 * 课程绑定多个教练
 * @param {*} param 
 * @returns 
 */
export function courseBlindCoach(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/course/courseBlindCoach',
        method: 'post',
        data: postData
    })
}

/**
 * 获取格式化的教练列表
 * @param {}} param 
 */
export function getFormatCoaches(param) {
    return request({
        url: '/api/manager/coach/formatcoaches',
        method: 'get',
        params: param
    })
}

/**
 * 获取课程id获取教练列表
 * @param {}} params 
 */
export function getCoachListsByCourseId(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coach/getCoachesByCourseId',
        method: 'post',
        data: postData
    })
}

/**
 * 获取未完课列表
 * @param {}} params 
 */
export function getCoachLists(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coach/getCoachInfo',
        method: 'post',
        data: postData
    })
}

/**
 * 删除未完课课程
 * @param {*} params 
 */
export function deleteCoach(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coach/deleteCoach',
        method: 'post',
        data: postData
    })
}

/**
 * 批量删除未完成课课程
 * @param {} params 
 */
export function batchDeleteCoach(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coach/batchDeleteCoach',
        method: 'post',
        data: postData
    })
}

/**
 * 添加未开课课程
 * @param {*} params 
 */
export function addCoach(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coach/addCoach',
        method: 'post',
        data: postData
    })
}

/**
 * 修改未开课课程
 * @param {*} params 
 */
export function editCoach(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/coach/editCoach',
        method: 'post',
        data: postData
    })
}

/**
 * 删除图片
 */
export function deleteImage(params) {
    let postData = qs.stringify(params)
    return request({
        url: '/api/manager/file/deletePhotos',
        method: 'post',
        data: postData
    })
}
// export function deleteImage(params){
//     let postData = qs.stringify(params)
//     return request({
//         url: '/api/manager/file/delete',
//         method: 'post',
//         data: postData
//     })
// }